import React from 'react';
import { Building2 } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-logo">
          <div className="footer-logo-icon">
            <Building2 size={24} />
          </div>
          <span className="footer-logo-text">TravelB2B</span>
        </div>
        <p className="footer-copyright">
          © {currentYear} TravelB2B Hub. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

